import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TwentyMp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7H16v3h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h18V3H3zm3.5 5h3V7h-3V5.5H11V9H8v1h3v1.5H6.5V8zm6 10.5H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5v6zm.5-13h4.5v6H13v-6zM18 17h-3v1.5h-1.5v-6H18V17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14h1.5v1.5H15z"
  }));
});
TwentyMp.displayName = 'TwentyMp';
export var TwentyMpDimensions = {
  height: 24,
  width: 24
};